import {
  imageSource,
  resolveImageAlt as coreResolveImageAlt,
  resolveImageChoiceAlt as coreResolveImageChoiceAlt,
  resolveProductImage as coreResolveProductImage,
  toLightboxSlides as coreToLightboxSlides,
} from '../../node_modules/@eliadmin/core/src/utils/image-alt-utils';

export { imageSource };

// Imported media can repeat its generated filename in custom_title. A digest is
// not a description; let the existing resolver use the product/brand context.
const GENERATED_NAME =
  /^(?:[a-f\d]{20,64}|[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12})(?:\.(?:avif|gif|jpe?g|png|svg|webp))?$/i;
const ALT_FIELDS = ['custom_title', 'alt', 'altText', 'name'] as const;
const record = (value: unknown): Record<string, unknown> | undefined =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;

function contextualImage(image: unknown): unknown {
  const data = record(image);
  if (!data) return image;
  const generated = ALT_FIELDS.filter(key => {
    const value = data[key];
    return typeof value === 'string' && GENERATED_NAME.test(value.trim());
  });
  if (!generated.length) return image;
  const result = { ...data };
  for (const key of generated) result[key] = undefined;
  return result;
}

export function resolveImageAlt(image: unknown, ...fallbacks: unknown[]): string {
  return coreResolveImageAlt(contextualImage(image), ...fallbacks);
}

export function resolveImageChoiceAlt(value: unknown, attribute: unknown): string {
  return coreResolveImageChoiceAlt(contextualImage(value), attribute);
}

export function toLightboxSlides(images: unknown, fallback?: unknown) {
  return coreToLightboxSlides(
    Array.isArray(images) ? images.map(contextualImage) : images,
    fallback,
  );
}

export function resolveProductImage(settings: unknown, product: unknown, variants: unknown) {
  const data = record(product);
  const contextualVariants = Array.isArray(variants)
    ? variants.map(variant => {
        const item = record(variant);
        return item && Array.isArray(item.images)
          ? { ...item, images: item.images.map(contextualImage) }
          : variant;
      })
    : variants;
  return coreResolveProductImage(
    settings,
    data ? { ...data, image: contextualImage(data.image) } : product,
    contextualVariants,
  );
}
